<template lang="pug">
footer
    //- .menu
    //-     .left
    //-         router-link.mainlogo(to="/")
    //-             img(src="@/assets/img/main-logo.svg")
    //-         a.companylogo(href="https://www.ts-h.co.jp/", target="_blank")
    //-             img(src="@/assets/img/ts-logo.svg")
    //-     .right
    //-         // WordPress用はここから 

    //-         // WordPress用はここまで

    //-         // WordPressの場合以下を削除
    //-         router-link.item(
    //-             v-for="item in icon",
    //-             :class="item.img",
    //-             :to="item.img",
    //-             :key="item.img"
    //-         )
    //-             .icon
    //-                 img(
    //-                     :src="iconUrl(item.img)",
    //-                     :style="{ width: item.width + '%' }"
    //-                 )
    //-             img.text(
    //-                 :src="textUrl(item.img)",
    //-                 :style="{ width: item.textwidth + 'px' }",
    //-                 :class="item.img"
    //-             )
    //-         // WordPressの場合ここまでを削除

    //-         a.item.contact(href="contact")
    //-             .icon
    //-                 img(:src="iconUrl('contact')", :style="{ width: '88%' }")
    //-             img.text.contact(
    //-                 :src="textUrl('contact')",
    //-                 :style="{ width: '31px' }"
    //-             )
    .copy ©Renode Luxe
</template>
<style lang="scss" scoped>
footer {
    @media #{$pc} {
        border-top: 2px solid #eceff1;
    }
    > .menu {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: space-between;

        @media #{$pc} {
            width: 1020px;
            flex-direction: row;
            padding: 5px 16px;
        }

        > .left {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            border-top: 2px solid #eceff1;
            width: 100%;

            @media #{$pc} {
                padding: 0;
                border: none;
                justify-content: flex-start;
            }

            img {
                width: 100%;
            }

            > .mainlogo {
                width: 91px;
                margin-right: 24px;
            }
            > .companylogo {
                width: 170px;
            }
        }

        > .right {
            display: flex;
            align-items: flex-start;
            padding: 8px;

            @media #{$pc} {
                padding: 0;
            }

            > .item {
                margin: 8px 16px;
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;
                @media #{$pc} {
                    margin: 8px;
                }
            }

            > .item.member,
            > .item.campaign {
                display: none;
                @media #{$pc} {
                    display: flex;
                    margin: 8px;
                }
            }

            > .item > .icon {
                height: 32px;
                width: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 5px;
            }

            > .item > .text {
                width: 100%;
                @media (-ms-high-contrast: none) {
                    height: 10px;
                }
            }

            > .item > .text.staff {
                padding-top: 1.8px;
                @media (-ms-high-contrast: none) {
                    height: 20px;
                }
            }
        }
    }

    > .copy {
        display: none;
        line-height: 25px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #424242;

        @media #{$pc} {
            display: block;
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            icon: [
                {
                    img: "member",
                    width: 95,
                    textwidth: 35,
                },
                {
                    img: "campaign",
                    width: 76,
                    textwidth: 41,
                },
                {
                    img: "staff",
                    width: 78,
                    textwidth: 39,
                },
                {
                    img: "recruit",
                    width: 75,
                    textwidth: 28,
                },
                // {
                //     img: "contact",
                //     width: 88,
                //     textwidth: 31
                // }
            ],
        };
    },
    methods: {
        iconUrl(file) {
            return require("@/assets/img/icon/" + file + ".svg");
        },
        textUrl(file) {
            return require("@/assets/img/icon/" + file + "_text.svg");
        },
    },
};
</script>
